import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router';

const Navigation = () => {
	return (
		<nav>
			<ul>
				<li>
					<NavLink to={'/#hero-animation'} className={({ isActive }) => (isActive ? 'selected' : '')}>
						<FormattedMessage id="home" />
					</NavLink>
				</li>
				<li>
					<NavLink to={'/team'} className={({ isActive }) => (isActive ? 'selected' : '')}>
						<FormattedMessage id="team" />
					</NavLink>
				</li>
				<li>
					<NavLink to={'/careers'} className={({ isActive }) => (isActive ? 'selected' : '')}>
						<FormattedMessage id="careers" />
					</NavLink>
				</li>
				{/* <li>
          <a href="/#contact">
            <FormattedMessage id="contact" />
          </a>
        </li> */}
			</ul>
		</nav>
	);
};

export default Navigation;
